import { getJson } from './client';
import type { SiteIntegrations } from './types';

/**
 * The booking widgets' two switches (see SiteIntegrations in types.ts). The
 * console only READS them, to say which install and which inbox the widget
 * pages use: the switches themselves are on the dispatch dashboard's Widgets
 * tab, beside the widgets they act on.
 */
export const getSiteIntegrations = () => getJson<SiteIntegrations>('/site_integrations');

/**
 * The install the booking-widget pages report to, or null: nothing linked, a
 * link that is broken (the pages get nothing from it, so saying they report
 * there would be false), or no answer at all — a failed read, or a service
 * that predates the switches and answers in some other shape. Every step is
 * guarded for that last one; the screens render exactly what they did before.
 */
export const widgetInstallId = (answer: SiteIntegrations | null | undefined): number | null => {
  const side = answer?.analytics;
  return side?.state === 'on' && typeof side.linked?.id === 'number' ? side.linked.id : null;
};

/** The website inbox the booking-widget pages chat through — the same rules. */
export const widgetInboxId = (answer: SiteIntegrations | null | undefined): number | null => {
  const side = answer?.chat;
  return side?.state === 'on' && typeof side.linked?.id === 'number' ? side.linked.id : null;
};
